import FlatList from "flatlist-react/lib";
import React, { useEffect, useMemo, useState } from "react";
import VideoPlayer from "../../../../components/VideoPlayer";
import VideoUploader from "../../../../components/VideoUploader";
import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import { getYoutubeVideoId, getYoutubeVideoThumbnail } from "../../../../utils";
import { ReactComponent as YoutubeIcon } from "../../../../assets/icons/youtube.svg";
import { Close } from "@mui/icons-material";
import PlayButtonSvgIcon from "../../../../assets/icons/videoButton";

const VideoSection = ({
  videos,
  onUpload,
  onRemove,
  isRenderOnModal = false,
}) => {
  const [openVideoPlayer, setOpenVideoPlayer] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [videoLinkModal, setVideoLinkModal] = useState(false);
  const [storedVideos, setStoredVideos] = useState([]);

  useEffect(() => {
    setStoredVideos(videos);
  }, [videos]);

  const handleVideoOpen = (data) => {
    setOpenVideoPlayer(true);
    setSelectedVideo(data);
  };

  const handleVideoClose = () => {
    setOpenVideoPlayer(false);
    setSelectedVideo(null);
  };

  const handleUploadVideo = () => {
    setVideoLinkModal(true);
  };

  const VideoAddComponent = () => {
    return (
      <Button
        onClick={handleUploadVideo}
        className="flex flex-row gap-1 rounded-md justify-center items-center"
        sx={{
          border: "1px solid #E7EBF1",
          borderRadius: "8px",
          padding: "6px 12px",
          "&:hover": {
            backgroundColor: "transparent",
            border: "1px solid #E7EBF1",
          },
        }}
      >
        <PlayButtonSvgIcon />
        <p className="text-[#687382] font-[10px]">Upload Videos</p>
      </Button>
    );
  };

  const renderItem = (item, index) => {
    return (
      <Box key={index} sx={{ position: "relative", display: "inline-block" }}>
        <Button
          onClick={handleVideoOpen?.bind(null, item)}
          className="p-0 text-white"
        >
          <div className="relative w-full cursor-pointer">
            <img
              src={getYoutubeVideoThumbnail(item?.url)}
              className="object-cover w-full aspect-square rounded"
            />
            <div className="w-full h-full absolute top-0 left-0 flex items-center justify-center">
              <YoutubeIcon />
            </div>
          </div>
        </Button>
        <IconButton
          sx={{
            position: "absolute",
            top: -7,
            right: -5,
            background: "#F3F3F3",
            width: 22,
            height: 22,
            zIndex: 10,
          }}
          size="small"
          onClick={() => onRemove(index)}
        >
          <Close sx={{ fontSize: "12px" }} />
        </IconButton>
      </Box>
    );
  };

  const ListEmpty = () => {
    return (
      <div className="text-center text-[16px] font-['Poppins-Medium']"></div>
    );
  };

  const RENDER_VIDEOS = useMemo(
    () => (
      <Stack space={2}>
        <FlatList
          key={"REFERENCE-VIDEO-LIST"}
          list={[...storedVideos]}
          renderItem={renderItem}
          renderWhenEmpty={ListEmpty}
          displayGrid
          minColumnWidth="100px"
          gridGap="10px"
        />
      </Stack>
    ),
    [storedVideos]
  );

  return (
    <Box>
      <Typography variant="h6">Reference Videos</Typography>
      <Box flexGrow={1} mt={2}>
        {RENDER_VIDEOS}
      </Box>
      <div className="mt-1">
        <VideoAddComponent />
      </div>
      <VideoPlayer
        url={selectedVideo?.url}
        open={openVideoPlayer}
        onClose={handleVideoClose}
      />
      <VideoUploader
        open={videoLinkModal}
        onClose={setVideoLinkModal?.bind(null, false)}
        onSubmit={(data) => {
          setVideoLinkModal(false);
          onUpload(data);
          if (isRenderOnModal) setStoredVideos((prev) => [...prev, data]);
        }}
      />
    </Box>
  );
};

export default VideoSection;
